import React, { useEffect, useRef } from 'react';
import prefersReducedMotion from './prefersReducedMotion';

/** Moves its children at a different speed than the page scroll (clamped to ±max px). */
export default function Parallax({ children, speed = 0.15, max = 160, className = '', style }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || prefersReducedMotion()) return undefined;
    let raf = 0;
    const update = () => {
      raf = 0;
      const host = el.parentElement || el;
      const r = host.getBoundingClientRect();
      const center = r.top + r.height / 2 - window.innerHeight / 2;
      const y = Math.max(-max, Math.min(max, -center * speed));
      el.style.transform = `translate3d(0, ${y.toFixed(1)}px, 0)`;
    };
    const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, [speed, max]);
  return <div ref={ref} className={`pnp-parallax ${className}`.trim()} style={style}>{children}</div>;
}
